module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "menu-builder__item-wrap",
    attrs: {
      "data-id": _vm.content.id
    }
  }, [(_vm.isReady) ? _c('div', {
    staticClass: "menu-builder__item"
  }, [_c('div', {
    staticClass: "menu-builder__item-inner"
  }, [_c('div', {
    staticClass: "menu-builder__item-title"
  }, [_c('span', [_vm._v(_vm._s(_vm.entity.name))])]), _vm._v(" "), _vm._m(0)])]) : _vm._e(), _vm._v(" "), (_vm.entity.children && _vm.entity.children.length) ? _c('ul', _vm._l((_vm.content.children), function(item) {
    return _c('term-item', {
      key: item.id,
      attrs: {
        "content": item
      }
    })
  }), 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-builder__item-btns"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-add"
  }, [_vm._v("Add item")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary btn-edit"
  }, [_vm._v("Edit")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger btn-delete"
  }, [_vm._v("Delete")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1ff8a52d","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/taxonomy/vocabulary/TermsOrderItem.vue
// module id = 837
// module chunks = 0